<template>
  <!--<bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">-->
  <!--<component  :is="currentTab" :currentTab='currentTab'></component>-->
  <!--</bsp-tabs>-->
  <div>
    <el-tabs v-model="tabIndex"  @tab-click="changeTab">
      <el-tab-pane
        :key="item.name"
        v-for="item in tabList"
        :label="item.title"
        :name="item.name"
        lazy="true"
      >
        <component  :is="item.name">

        </component>

      </el-tab-pane>
      <div class="btnCon">
        <el-button type="primary" size="small" @click="backToCodeSet()">返回</el-button>
      </div>
    </el-tabs>
  </div>
</template>
<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
  import taxNormalWagesList from '@/views/wage/salaryTax/taxtabson/taxNormalWagesList';
  import taxIncomeWagesList from '@/views/wage/salaryTax/taxtabson/taxIncomeWagesList';
  import taxPersonEquityList from '@/views/wage/salaryTax/taxtabson/taxPersonEquityList';
  import taxQuitWagesList from '@/views/wage/salaryTax/taxtabson/taxQuitWagesList';
  import taxAnnualWagesList from '@/views/wage/salaryTax/taxtabson/taxAnnualWagesList';
  import empWagesList from '@/views/wage/salaryTax/taxtabson/empWagesList';
  import empQuitWagesList from '@/views/wage/salaryTax/taxtabson/empQuitWagesList';
  export default {
    data() {
      return {
        tabList: [
        //   {
        //   title: '人员信息',
        //   name: 'taxEmpLsit'
        // },
          {
          title: '正常工资所得',
          name: 'empWagesList'
        },
        //   {
        //   title: '非居民正常工资薪金所得',
        //   name: 'taxResidentWagesList'
        // },
        //   {
        //   title: '劳务报酬所得',
        //   name: 'taxIncomeWagesList'
        // },{
        //   title: '个人股权激励收入',
        //   name: 'taxPersonEquityList'
        // },
           {
           title: '解除劳动合同一次性补偿金',
           name: 'empQuitWagesList'
         }
          // {
        //   title: '全年一次性奖金',
        //   name: 'taxAnnualWagesList'
        // }


        ],
        tabIndex: 'empWagesList',
        // currentTab:'tabson1',
      }
    },
    components:{
      bspTabs,
      //  taxEmpLsit,
      taxNormalWagesList,
     //  taxResidentWagesList,
      taxIncomeWagesList,
      taxPersonEquityList,
      taxQuitWagesList,
      taxAnnualWagesList,
      empWagesList,
      empQuitWagesList

    },
    methods: {
      changeTab(tab, event) {
        //  this.currentTab = tab.name;
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
    }
  }
</script>
<style scoped>
  .btnCon{
    position: absolute;
    right: 0;
    top: -32px;
  }
</style>
